import { render, staticRenderFns } from "./ManageIntroVideoPage.vue?vue&type=template&id=22cffd36&"
import script from "./ManageIntroVideoPage.vue?vue&type=script&lang=js&"
export * from "./ManageIntroVideoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports